import { Fragment, FunctionComponent } from "react";

import "./MapControl.css";

interface MapControlProps {
  items: {
    icon: React.ReactNode;
    key: string;
    onPress: () => void;
  }[];
  buttonRef?: React.RefObject<HTMLDivElement>;
}

const MapControl: FunctionComponent<MapControlProps> = ({
  items,
  buttonRef,
}) => {
  return (
    <div className="map-control-component" ref={buttonRef}>
      {items.map((item, index) => (
        <Fragment key={item.key}>
          <button onClick={item.onPress}>{item.icon}</button>
          {index < items.length - 1 && <div className="divider" />}
        </Fragment>
      ))}
    </div>
  );
};

export { MapControl };
